export enum AlarmState {
	Alarm = 'ALARM',
	Deactivated = 'DEACTIVATED',
	None = 'None',
	Ok = 'OK',
	Warning = 'WARNING',
}
